<template>
 <yd-countdown
  :time="time"
  format="{%d}天{%h}时{%m}分{%s}秒后截止"
  timetype="second">
</yd-countdown>
</template>
<script>
  export default {
    props: ['time']
  }
</script>
<style scoped></style>



// WEBPACK FOOTER //
// index.vue?82ea97a4